import React, { useCallback, useEffect, useState, useRef } from "react";
import Plot from 'react-plotly.js';
import { useWebSocketConnection } from "../../services/connectionContext/connectionContext";
import { Box, Typography } from "@mui/material";

// function valuetext(value) {
//     return `${value}`;
// }

// const marks = [
//     { value: 0, label: '0m' },
//     { value: 4, label: '4m' },
//     { value: 8, label: '8m' },
//     { value: 12, label: '12m' },
// ];

// function scaleThres(x, thres) {
//     let fx = 7. / ((x + 2.) / 10);
//     return fx + thres;
// }

export const ValueListPlot = React.memo(({ title, socketTargetsEvent }) => {
    const { eventEmitter } = useWebSocketConnection();

    const [targetList, setTargetList] = useState([
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
    ]);

    // CHANGED: Hier der Ref für den Datenpuffer
    const targetListRef = useRef([
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
    ]);

    // CHANGED: Ankommende Daten ins Ref schreiben
    const append_list = useCallback((msg) => {
        if (msg && msg.header && msg.header.timestamp_read && msg.values_abs) {
            const currentRef = [...targetListRef.current];
            currentRef.forEach((trace, i) => {
                const newX = [...trace.x, msg.header.timestamp_read];
                const newY = [...trace.y, msg.values_abs[i]];

                if (newX.length > 256) {
                    newX.shift();
                    newY.shift();
                }

                trace.x = newX;
                trace.y = newY;
            });
            targetListRef.current = currentRef;
        }
    }, []);

    useEffect(() => {
        eventEmitter.on(socketTargetsEvent, append_list);

        // CHANGED: Throttled Aktualisierung
        const intervalId = setInterval(() => {
            setTargetList(targetListRef.current);
        }, 100); // 10 Hz

        return () => {
            eventEmitter.off(socketTargetsEvent, append_list);
            clearInterval(intervalId);
        }
    }, [eventEmitter, socketTargetsEvent, append_list]);

    return (
        <Box>
            <Typography>
                {title}
            </Typography>
            <Plot
                style={{ float: "center", height: "500px", width: "100%", minHeight: 400 }}
                data={targetList}
                layout={{
                    paper_bgcolor: 'rgba(0,0,0,0)',
                    plot_bgcolor: 'rgba(0,0,0,0)',
                    showlegend: true,
                    legend: { orientation: "h" },
                    xaxis: { showgrid: true, showline: true, gridwidth: 1, gridcolor: '#bbbbbb' },
                    yaxis: { showgrid: true, showline: true, gridwidth: 1, gridcolor: '#bbbbbb' }
                }}
                useResizeHandler={true}
            />
        </Box>
    );
});
